import React, { useState } from 'react';
import { getService } from '@Client/runner.hooks/useService';
import {
  CustomTabs,
  ICustomTab
} from '@Shared.Angular/flowingly.components/CustomTabs/CustomTabs';
import WorkflowReportsTab from './Tabs/WorkflowReportsTab';
import UserReportsTab from './Tabs/UserReportsTab';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { CustomTabPanel } from '@Shared.Angular/flowingly.components/CustomTabs/CustomTab/CustomTabPanel';
import TagReportsTab from './Tabs/TagReportsTab';
import FlowModelReportsTab from './Tabs/FlowModelReportsTab';
import ProcedureReportsTab from './Tabs/ProcedureReportsTab';
import EmptyState from '@Client/runner.directives/common/EmptyState';

export const Reports = () => {
  const APP_CONFIG = getService('APP_CONFIG');
  const permissionsService = getService('permissionsService');

  const tabs: ICustomTab[] = [
    {
      id: ReportTabId.WORKFLOWS,
      label: 'Workflows',
      isDisabled: false,
      isHidden: !APP_CONFIG.allowWorkflow
    },
    {
      id: ReportTabId.FLOW_MODELS,
      label: 'Flow Models',
      title: 'Reports for Process Maps & Workflows',
      isDisabled: false,
      isHidden:
        (!APP_CONFIG.allowProcessMap && !APP_CONFIG.allowWorkflow) ||
        !permissionsService.currentUserHasPermission(
          FlowinglyPermissions.LIBRARY_ACCESS
        )
    },
    {
      id: ReportTabId.PROCEDURES,
      label: 'SOPs',
      isDisabled: false,
      isHidden:
        !APP_CONFIG.enableProcedures ||
        !permissionsService.currentUserHasPermission(
          FlowinglyPermissions.REPORT_ACCESS
        )
    },
    {
      id: ReportTabId.USERS,
      label: 'Users',
      isDisabled: false,
      isHidden: !permissionsService.currentUserHasPermission(
        FlowinglyPermissions.SETUP_USER_ACCESS
      )
    },
    {
      id: ReportTabId.TAGS,
      label: 'Tags',
      isDisabled: false,
      isHidden:
        !permissionsService.currentUserHasPermission(
          FlowinglyPermissions.LIBRARY_ACCESS
        ) || !APP_CONFIG.enableTagging
    }
  ];

  const [selectedTabId, setSelectedTabId] = useState(
    tabs.find((tab) => !tab.isHidden)?.id
  );

  const userCanSeeReports = tabs.some((tab) => !tab.isHidden);

  return (
    <div id="reports-page" className="runner-page">
      {userCanSeeReports && (
        <>
          <CustomTabs
            selectedTabId={selectedTabId}
            onChange={setSelectedTabId}
            tabItems={tabs}
            fitContent={true}
          ></CustomTabs>
          <CustomTabPanel
            tabId={ReportTabId.WORKFLOWS}
            isShown={selectedTabId === ReportTabId.WORKFLOWS}
          >
            <WorkflowReportsTab />
          </CustomTabPanel>
          <CustomTabPanel
            tabId={ReportTabId.FLOW_MODELS}
            isShown={selectedTabId === ReportTabId.FLOW_MODELS}
          >
            <FlowModelReportsTab />
          </CustomTabPanel>
          <CustomTabPanel
            tabId={ReportTabId.USERS}
            isShown={selectedTabId === ReportTabId.USERS}
          >
            <UserReportsTab />
          </CustomTabPanel>
          <CustomTabPanel
            tabId={ReportTabId.TAGS}
            isShown={selectedTabId === ReportTabId.TAGS}
          >
            <TagReportsTab />
          </CustomTabPanel>
          <CustomTabPanel
            tabId={ReportTabId.PROCEDURES}
            isShown={selectedTabId === ReportTabId.PROCEDURES}
          >
            <ProcedureReportsTab />
          </CustomTabPanel>
        </>
      )}
      {!userCanSeeReports && <EmptyState bodyText="No reports available" />}
    </div>
  );
};

enum ReportTabId {
  WORKFLOWS = 'workflows',
  FLOW_MODELS = 'flowmodels',
  USERS = 'users',
  TAGS = 'tags',
  PROCEDURES = 'procedures'
}
